import { getShareHost } from 'config/environment'
import { makeAutoObservable, observable } from 'mobx'
import { useMemo } from 'react'
import { Product } from 'type/Product'
import { Share, TryonProduct } from 'type/tryon'
import { by_card, by_email, is_baga } from 'util/opt'

class OptionsStore {
  product: Partial<Product> = {}
  options: Partial<TryonProduct> = {}

  constructor() {
    makeAutoObservable(this, { product: observable.ref, options: observable.ref })
  }

  init(product: Partial<Product>, options: Partial<TryonProduct>) {
    this.product = product
    this.options = options
  }

  get company(): string {
    return this.product.company_id || ''
  }

  get tsum(): boolean {
    return this.company === 'tsum_cs'
  }

  get irnby(): boolean {
    return this.company === 'd2596011-9aba-4e18-809f-bed7cfe5e6f7'
      || this.product.product_id === '1318fa6f-817e-429b-9c4a-1b8bc32e28d6'
  }

  get baga(): boolean {
    return is_baga(this.company)
  }

  get sela(): boolean {
    return this.company === '1e2f902b-c114-4dcc-a6cc-5e37a612c2be'
      || this.product.product_id == '99f20158-7578-4afa-a41a-aa62199f0fcb'
  }

  get foo(): boolean {
    return this.company === '519e6622-fb56-442a-ab19-ff69eef71ed9'
      || this.company === 'f5069533-2038-4117-b9ad-da0ca83cb27d'
  }

  get sizing(): boolean {
    return !!this.product.sizing
  }

  get by_email(): boolean {
    return by_email(this.company)
  }

  get by_card(): boolean {
    return by_card(this.company)
  }

  get sochi(): boolean {
    return this.company === '346f34ab-7a92-43cd-8a18-6e79d382da70'
      || this.company === 'abc132ec-2353-4d8b-a60d-4c103db81066'
  }

  get salaris(): boolean {
    return this.company === 'dccc94fc-49cf-4893-8073-c3c7154d6eb2'
  }

  get share_host(): string {
    if (this.sela) return 'https://ai-fit.sela.ru'
    return getShareHost()
  }

  get square(): boolean {
    return this.irnby
  }

  get utm_buy(): string {
    return this.product.utm_buy || ''
  }

  get gender(): string | undefined {
    return this.options.gender
  }

  radius(radius: number): number
  radius(radius: number | null | undefined): number | undefined
  radius(radius: number): number {
    return this.square ? 0 : radius
  }

  get share(): Set<Share> {
    const share = this.options?.share ?? []
    if (share?.length) return new Set(share)
    return new Set(['looky', 'telegram', 'whatsapp'])
  }
}

export const opt = new OptionsStore()

export function useOpt(product: Product | undefined, widget: TryonProduct | undefined) {
  useMemo(() => opt.init(product ?? {}, widget ?? {}), [product, widget])
}
